import { render, staticRenderFns } from "./huodong.vue?vue&type=template&id=f7ce3520&scoped=true&"
import script from "./huodong.vue?vue&type=script&lang=js&"
export * from "./huodong.vue?vue&type=script&lang=js&"
import style0 from "./huodong.vue?vue&type=style&index=0&id=f7ce3520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ce3520",
  null
  
)

export default component.exports